import FormInputTypes from "../components/atoms/formEnums/formInputTypes";
import tableAppTeamsToCameraContent from "./tableAppTeamsToCameraContent";

export default {
  title: 'Teams in camera',
  attributeName: 'appTeamsToCameraContent',
  fields: [
    {
      attributeName: 'teamsToCameraContentTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableAppTeamsToCameraContent,
      
    },
  ],
  visibleWhen:[{"field":"hasTeams","value":true},{"field":"isLive","value":true}]
};
